import { ArcRotateCamera } from '@babylonjs/core/Cameras/arcRotateCamera'
import { Mesh } from '@babylonjs/core/Meshes/mesh'
import { Vector3 } from '@babylonjs/core/Maths/math.vector'

export function zoomOnCamera (mesh: Mesh, camera: ArcRotateCamera) {
  if (!mesh) return

  const { max, min } = mesh.getHierarchyBoundingVectors(true, x => x.isVisible)
  const ratio = camera.getScene().getEngine().getAspectRatio(camera, true)

  let vfov = camera.fov
  let hfov = Math.atan(Math.tan(vfov / 2.0) * ratio) * 2.0
  const vRadius = getMaxRadius(vfov, hfov, ratio, max, min)

  camera.fovMode = ArcRotateCamera.FOVMODE_HORIZONTAL_FIXED
  hfov = camera.fov
  vfov = Math.atan(Math.tan(hfov / 2.0) * ratio) * 2.0
  const hRadius = getMaxRadius(vfov, hfov, ratio, max, min)

  if (hRadius > vRadius) {
    camera.fovMode = ArcRotateCamera.FOVMODE_HORIZONTAL_FIXED
  } else {
    camera.fovMode = ArcRotateCamera.FOVMODE_VERTICAL_FIXED
  }
  camera.radius = Math.max(vRadius, hRadius)
}

function getMaxRadius (vfov: number, hfov: number, ratio: number, max: Vector3, min: Vector3) {
  const vtheta = vfov / 2
  const vr = (max.y - min.y) / 2
  const vdistance = vr / Math.sin(vtheta)

  const htheta = hfov / 2
  const hr = (max.x - min.x) / 2
  const hdistance = hr / Math.sin(htheta)

  return Math.max(hdistance, vdistance)
}
